export default {
  //全局字典项
  logout: "Exit",
  userCode: "User Name",
  group: "Group",
  hotelGroupName: "Group",
  hotelName: "Hotel",
  bizDate: "Bus.Date",
  code: "User",
  name: "Name",
  sex: "Gender",
  roles: "Position",
  mobile: "Mobile",
  createDatetime: "Created on",
  modifyDatetime: "Last Login Time",
  lastLoginDate: "Last Login Time",
  lastIp: "Last IP",
  mac: "Unique ID",
  view: "View",
  more:"More",
  add: "Add",
  delete: "Delete",
  search: "Search",
  cancel: "Cancel",
  exit:"Exit",
  determine: "OK",
  selectAll:"All",
  fliter: "Filter",
  complete: "OK",
  share: "Share",
  refresh: "Refresh",
  home: "Home",
  all: "All",
  other: "Other",
  multi_select: "MultiSelect",
  edit: "Edit",
  Copy: "Copy",
  CopySuccess:"Success",
  myApp: "My APP",
  operate: "Operation",
  reset: "Reset",
  empty:'Clear',
  maintenance: "OO",
  lock: "OS",
  reservation: "Resv.",
  back: "Back",
  remark: "Comments",
  success: "Successfully",
  reason: "Reason",
  nothing:"There's nothing",
  senior: "Senior",
  search: "Search",
  list: "List",
  gantt_chart: "Gantt",
  site: "Venue",
  modify: "Edit",
  shutDown: "Close",
  hotel: "Hotel",
  save: "Save",
  morning: "AM",
  afternoon: "PM",
  evening: "Eve",
  Sunday: "Sun",
  Monday: "Mon",
  Tuesday: "Tue",
  Wednesday: "Wed",
  Thursday: "Thur",
  Friday: "Fri",
  Saturday: "Sat",
  thisYear: "Current Year",
  lastYear: "Last Year",
  hundredmillion: "M",
  tenThousand: "K",
  month: "Month",
  placeHolder_Empty:"Can be empty",
  sum:"Sum",
  bi:"",
  loading_end_message: "—— 　I am the bottom line　 ——",
  sexDesc: "Gender",
  sexMale: "male",
  sexFemale: "female",
  status: "Status",
  clear: 'Clear',
  prderDetail_opera_num: 'Num',
  prderDetail_no_data: 'No Record',
  prderDetail_opera_fee_type: 'Fee Type',
  prderDetail_opera_notice: 'Fee Type only show Ohotel set type',

  book_no_ratecode: 'No this type rateCode',

  //全局字典项
  MessageBox_title: "Tips",
  MessageBox_confirmButtonText: "OK",
  MessageBox_cancelButtonText: "Cancel",
  MessageBox_areYouSure: "Sure to exit？",
  MessageBox_unRepair: "Sure to remove？",
  MessageBox_keepDebts: "Sure to suspend?",
  MessageBox_checkOutAdd: "Sure to post Room charge?",
  MessageBox_checkOutAdd_select: "Please select charge type",
  MessageBox_checkOutAdd_action0: "Half day",
  MessageBox_checkOutAdd_action1: "One day",
  MessageBox_checkOutAdd_action0_sure: "Sure to charge Half day?",
  MessageBox_checkOutAdd_action1_sure: "Sure to charge One day?",
  MessageBox_checkIn: "Sure to check in?",
  MessageBox_cancelOrder: "Please enter the reason of cancellation（Or null）",
  MessageBox_delete_meeting: "Sure to delete:",
  MessageBox_cancel: "Sure to cancel?",
  MessageBox_cancelMeeting: "Sure to batch edit?",
  MessageBox_use: "Sure to use？",
  MessageBox_selectShiftTitle: 'Choose shift',
  MessageBox_msg_selectShift: 'Please choose shift',

  msg_delete_success: "Deleted successfully",
  msg_use_success: "Used successfully",
  msg_update_success: "successfully",
  msg_cancel_success: "successfully",
  msg_modify_success: "successfully",
  msg_checkin_success: "Checked in successfully",
  msg_addReceive_success: "Posted successfully",
  msg_keepDebts_success: "Suspended successfully",
  msg_recognize_fail: "Speech recognition failed:",
  msg_choose_room: "Please select a room",
  msg_choose_checkMethod: "Please select payment",
  //book msg
  msg_error_code: "Identification failed! Please aim at the ID card and take the picture when it is clear。",
  msg_rsvCompanyId4: "Please enter the agent",
  msg_rsvCompanyId3: "Please enter the company",
  msg_rsvCompanyId2: "Please enter the member information",
  msg_rsvMan: "Name cannot be empty",
  msg_rmtype: "Room type cannot be empty",
  msg_idCode: "ID type cannot be empty",
  msg_range: "Arrival/departure date cannot be empty",
  msg_search: "Please enter the searvh criteria",
  msg_could_not_find: "No found",
  msg_choose_reason: "Please select the reason",
  msg_no_more_room: "Over the number of rooms",
  msg_submitGear: "Please click the Room assign or Check in",
  msg_reserveBook: "Please select the venue and time",
  msg_salesman: "Sales cannot be empty",
  msg_phone: "Contact phone cannot be empty",
  msg_theme: "Subject cannot be empty",
  msg_category: "Banquet type cannot be empty",
  msg_linkman: "Contacts cannot be empty",
  msg_cateringPlaceString: "Venue cannot be empty",
  msg_beginDateString: "Begin date cannot be empty",
  msg_endDateString: "End date cannot be empty",
  msg_meetingBook_sta: "Status cannot be empty",
  msg_meetingBook_update: "Save successfully",
  msg_meetingBook_Success:"Reserved successfully！",
  msg_cancelMeeting: "Cancel successfully",
  msg_handleConfirmEnd: "The end date is later than the begin date。",
  msg_save_fail: "Save failed",

  msg_nav: "The function requires PMS version:",
  msg_getDetail: "This coupon cannot be used",
  msg_getbarcode: "Not the types of coupons can be used",
  Toast_nomorethan5: "Warning events cannot more than 5",
  Toast_nomorethan11: "You can add up to 11 ",
  Toast_selectcondition: "Please select the different index!",
  Toast_pickDate: "No more than 5 days from beginning to end",
  Toast_pickDate1: "The Max. must be greater than Mix.",
  Toast_addNewTime: "The warning time conditions cannot more than 3",
  Toast_checkCondition: "Please finish the judgement condition",
  Toast_checkCondition1: "Please finish the judgement condition",
  Toast_checkCondition2: "Data upper limit must be greater than data lower limit",
  Toast_del_last: "Cannot delete the last one",
  Toast_save_rule: "Please enter the event name",
  Toast_save_rule1: "Please enter the Date range",
  Toast_save_rule_time: "Please enter the warning time",
  Toast_noticeContent: "Please enter the content",
  Toast_save_success: "Save successfully！",
  //导航 首页
  index_refresh: "Pull-refresh",
  index_homeData_title: "Today Total Rev.",
  index_homeData_analy: "Avl.",
  index_homeData_analy_unit: "Rms",
  index_homeData_analysis: "Occ.%",
  index_homeData_analysis_avg: "ADR",
  index_homeData_angle_allNum: "Total",
  index_homeData_angle_allNum_unit: "Rms",
  index_homeData_angle_sorted: "Occ.",
  index_homeData_angle_sorted_rate: 'Sale.%',
  index_homeData_angle_sort: "Avl.",
  index_homeData_angle_takeUp: "Occ.",
  index_homeData_angle_maintenance: "OO",
  index_homeData_angle_personalUse: "HSE",
  index_homeData_angle_free: "COMP",
  index_homeData_angle_lock: "OS",

  index_homeData_angle_lock_oo: 'OO',
  index_homeData_angle_lock_os: 'OS',

  index_homeData_notarrRoom: "Not Arrived",
  index_homeData_isarrRoom: "Arrived",
  index_homeData_notdepRoom: "Not Dep",
  index_homeData_isdepRoom: "Dep",

  index_homeData_define: "Index definition",
  index_new_version:" New version description",
  footNav_home: "Home",
  footNav_info: "Message",
  footNav_discover: "Discover",
  footNav_center: "Me",
  //moreFunction
  moreFunction_tip: "Drag to adjust sorting ",
  //login
  login_hotelCode: "Hotel Code",
  login_username: "User Name",
  login_password: "Password",
  login_login: "Login",
  login_pleseRemember: "Remember",
  login_saved_Password:"[Password]",
  login_hotelCode_Not_Empty: "Hotel Code Can't be Empty",
  login_username_Not_Empty: "User Name Can't be Empty",
  login_password_Not_Empty: "Password Can't be Empty",
  login_only_code: "Unique ID",
  //serarch
  search_title: "Switch Hotel",
  search_placeholder: "Hotel Code/Name",
  search_often: "History",
  search_city:"City",
  search_brand: "Brand",
  search_area: "Area",
  search_hotel: "Hotel",
  search_all: "All",
  // fangT
  fangT_placeholder: "Rm No./Name",
  fangT_title: "Rm Status",
  fangT_category_name: "Category",
  fangT_rmno: "Rm No.",
  fangT_rmno_placeholder: "Please enter the room No.",
  fangT_staNew: "Status",
  fangT_rmnos: "Rm No.",
  fangT_rmnos_placeholder: "Enter the room No.（Must fill in）",
  fangT_sta: "Status",
  fangT_beginDate: "Begin",
  fangT_endDate: "End",
  fangT_reasonCode: "Reason",
  fangT_remark_placeholder: "Can be empty",
  fangT_mutlSelectTitle: "Selected 0 Rms",
  fangT_mutlSelectTitleText: "Selected",
  fangT_mutlSelectTitUnit: "Rms",
  fangT_view: "View",
  fangT_RoomStaI: "Inspected",
  fangT_RoomStaR: "Clean",
  fangT_RoomStaD: "Dirty",
  fangT_RoomStaPU: "Repair",
  fangT_reserveBook: "Resv.",
  fangT_walkBook: "C/I",
  fangT_RoomStaOOO: "OO",
  fangT_RoomStaOOS: "OS",
  fangT_unRepair: "Remove",
  fangT_building: "Building",
  fangT_floor: "Floor",
  fangT_rmtype: "Rm type",
  fangT_feature: "Features",
  fangT_villadataV: "Available",
  fangT_villadataB: "Large Rm No.",
  fangT_villadataS: "Small Rm No.",

  // opera新增的
  fangT_sure_prev: 'Sure to change room ',
  fangT_sure_clean: ' status to clean?',
  fangT_sure_dirty: ' status to dirty?',
  fangT_sure_inspected: ' status to inspected?',
  fangT_sure_small_build: 'Please choose buildings first when view small rooms',
  fangT_sure_small_build_most_before: 'You can most select ',
  fangT_sure_small_build_most_after: ' buildings',
  fangT_sure_same_status: 'Can not choose different status room',
  fangT_sure_check_small: 'View small room status',
  fangT_sure_check_orderDetail: 'View order detail',


  //fangQ
  fangQ_title: "House Status",
  fangQ_title1: "Business ",
  fangQ_title2: "Room ",
  fangQ_date: "Date",
  fangQ_takeup: "Occ.",
  fangQ_available: "Avl.",
  fangQ_maintenance: "OO",
  fangQ_average_price: "ADR",
  fangQ_rents: "Occ.%",
  fangQ_action: "Oper.",
  fangQ_detail: "DTL>",
  fangQ_orderDetail_free: "Free",
  fangQ_select_modal: 'Room Type',
  fangQ_select_title: 'Room Type Select',
  fangQ_left_top_title: 'Building',
  fangQ_left_bottom_title: 'Big Room Type',
  fangQ_notice_text: 'Current select',

  //fangXQ
  fangXQ_title: "Room Status",
  fangXQ_rmtype: "Rm Type",
  fangXQ_total_num: "Total",
  fangXQ_available: "Avl.",
  fangXQ_takeup: "Occ",
  fangXQ_maintenance: "OO",
  fangXQ_toogle_type: "Type",
  fangXQ_toogle_detail: "Detail",
  //book
  book_title: "Reservation",
  book_active1: "FIT",
  book_active2: "Member",
  book_active3: "Company",
  book_active4: "OTA",
  book_active5: "Agent",
  book_name5: "Agent",
  book_name4: "OTA",
  book_name3: "Company",
  book_name2: "Member",
  book_rsvMan: "Name",
  book_rsvMan_placeholder: "Must fill in",
  book_mobile: "Mobile",
  book_mobile_placeholder: "Can be empty",
  book_idCode: "ID type",

  book_idNo: "ID No.",
  book_idNo_placeholder: "Can be empty",
  book_idNo_placeholder_required: "Required",
  book_range: "Arr./Dept.",
  book_rmnum: "Rms",
  book_rmno: "Rm No.",
  book_rmtype: "Rm Type",
  book_ratecode: "Rate Code",
  book_firstDayMoney: "First Day Rate",
  book_pkage: "Package",
  book_more_parmas: "More",
  book_packup_parmas: "Hide",
  book_rateSecret: "No Print Rate",
  book_rsvType: "Resv. Type",
  book_market: "Market",
  book_src: "Source",
  book_channel: "Channel",
  book_cms_code: "Commision",
  book_payCode: "Payment",
  book_salesman: "Sales",
  book_salesman_placeholder: "Please select the sales",
  book_coMsg:"C/O Msg.",
  book_otaRsvNo:"OTA Resv. No.",
  book_creditMan:"Manuel No.",
  book_specials:"Special",
  book_amenities:"Amenities",
  book_origin_price: 'Origin',
  book_reason: 'Reason',
  book_sync: 'Sync',
  book_select_type: 'Please select room type',
  book_reset_price_notice: 'Basic info changed, Please reset reduction',
  book_define_title: 'Set room rate',

  book_remark: "Comments",
  book_amount: "Total",
  book_count: "Charge Detail",
  book_rmnum: "Rm Charge",
  book_total: "Total Charge",
  book_reserveBook: "Resv.",
  book_walkBook: "C/I",
  book_disRmType_des: "（No rooms）",
  book_disRmType_left: " -- ",
  book_disRmType_unit: "Rms",
  book_addRmType_btn: 'Add rm type',
  book_removeRmType_btn: 'Delete rm type',

  //fangTXQ
  fangTXQ_title: "Registration",
  fangTXQ_rsvNo: "Resv. No.",
  fangTXQ_sta: "Status",
  fangTXQ_baseInfo: "Basic Info",
  fangTXQ_reserveBook: "Resv.",
  fangTXQ_name: "Name",
  fangTXQ_mobile: "Mobile",
  fangTXQ_name2: "Name2",
  fangTXQ_firstName: "Last/First Name",
  fangTXQ_rmno: "Rm No.",
  fangTXQ_rmtype: "Rm Type",
  fangTXQ_arr: "Arr.",
  fangTXQ_dep: "Dept.",
  fangTXQ_memberNo: "Member No.",
  fangTXQ_realRate: "Rate",
  fangTXQ_idCode: "ID type",
  fangTXQ_idNo: "ID No.",
  fangTXQ_idNo_placeholder: "Please enter the ID No.",
  fangTXQ_companyName: "Company",
  fangTXQ_agentName: "Agent",
  fangTXQ_sourceName: "OTA",
  fangTXQ_pmsTimesIn: 'HotelIn times',
  fangTXQ_timesIn: 'GroupIn times',
  fangTXQ_ratecode: "Rate Code",
  fangTXQ_market_sales: "Market&Sales",
  fangTXQ_salesman: "Sales",
  fangTXQ_rsvTypeName: "Resv. Type",
  fangTXQ_market: "Market",
  fangTXQ_src: "Source",
  fangTXQ_cmscode: "Commision",
  fangTXQ_channel: "Channel",
  fangTXQ_payCode: "Payment",
  fangTXQ_crsNo: "CRS No.",
  fangTXQ_packagesDis: "Package",

  fangTXQ_other: "Other",
  fangTXQ_remark: "Comments",
  fangTXQ_createUser: "Created by",
  fangTXQ_createDatetime: "Created on",
  fangTXQ_modifyUser: "Updated by",
  fangTXQ_modifyDatetime: "Updated on",
  fangTXQ_sepcials: "specials",

  fangTXQ_live_with: "Share With",
  fangTXQ_none: "None",
  fangTXQ_al_room: "Party Room",

  fangTXQ_bill: "Billing",
  fangTXQ_masterBase: "Balance",
  fangTXQ_credit: "Credit",
  fangTXQ_othBalance: "Total Balance",
  fangTXQ_othCredit: "Total Credit",
  fangTXQ_coMsg: "C/O Msg.",
  fangTXQ_project: "Item",
  fangTXQ_time: "Time",
  fangTXQ_operator: "User",
  fangTXQ_amount: "Amt",
  fangTXQ_cancelOrder: "Cancel",
  fangTXQ_checkIn: "C/I",
  fangTXQ_addReceive1: "One Day",
  fangTXQ_addReceive0: "Half Day",
  fangTXQ_keepDebts: "Suspend",
  fangTXQ_checkOut: "C/O",

  fangTXQ_needMoney: "Total Charge",
  fangTXQ_needMoney2: "Payment Amount",
  fangTXQ_checkMethod: "Payment Code",
  fangTXQ_payName: "Pay by",
  fangTXQ_invoice_title: "Invoice Title",

  fangTXQ_date: "Date",
  fangTXQ_rate: "Rate",
  fangTXQ_rmnum: "Rms",
  fangTXQ_total: "Total",

  fangTXQ_addReceiveMsg0: "Sure to post half day Rm charge?",
  fangTXQ_addReceiveMsg1: "Sure to post one day Rm charge?",

  fangTXQ_orderDisD: "Hourly",
  fangTXQ_orderDisG: "Group",
  fangTXQ_amenities:"Amenities",
  fangTXQ_specials:"Special",
  fangTXQ_creditMan:"Manuel No.",
  fangTXQ_otaRsvNo:"OTA Resv. No.",

  fangTXQ_changeRoomTitle: 'Choose room to change',
  fangTXQ_changeRoomNoRoom: 'No room avaliable for change',
  fangTXQ_changeRoomSuccess: 'Change room success',

  fangTXQ_scanPay_title:'Scan Pay',
  fangTXQ_bookName:'Check Name',
  fangTXQ_bookTime:'Check Time',
  fangTXQ_savePictrue:'Save picture',
  fangTXQ_forwardWechat:'Forward WeChat',
  fangTXQ_generateQrCode:'Generate QrCode',
  fangTXQ_transactionAmount:'Transaction amount',
  fangTXQ_pleaseTransactionAmount:'Please enter the transaction amount',
  fangTXQ_cannotTransactionAmount:'Transaction cannot be empty',

  // 扫码支付
  scanPay_title: 'Scan Pay',
  scanPay_save: 'Post',
  scanPay_money_placeholder: "Please enter the amount（Must fill in）",
  scanPay_rmno: "Rm No.",
  scanPay_name: "Name",
  scanPay_taCode: "Code",
  scanPay_money: "Amount",
  scanPay_taNo: "Reference",
  scanPay_taRemark: "Supplement",
  scanPay_history: 'ScanPay History',
  scanPay_operator: "User",
  scanPay_date: "Date",
  scanPay_refund: 'Refund',
  scanPay_refund_check: 'Refund Check',
  scanPay_slide_notice: 'Slide left to Refund or Refund Check',
  scanPay_action_reAccount: "Posting Check",
  scanPay_action_reAccountSuccess: "Posting Check Successfully",
  scanPay_success:"Refund Successfully",

  scanPay_refund_amount: 'left refund amount',
  scanPay_no_refund_amount: 'No refund amount left',
  scanPay_refund_amount_placeholder: 'enter refund amount',
  scanPay_refund_error_money: 'Please enter refund amount',
  scanPay_refund_error_money2: 'Refund amount is too much',

  // 添加同住人
  addLiveWith_title: 'Add share with',
  addLiveWith_no_name: 'Please enter the name',
  addLiveWith_no_sex: 'Please select gender',
  addLiveWith_no_vip: 'Please select VIP',
  addLiveWith_nation: 'nationality',
  addLiveWith_language: 'language',
  addLiveWith_checkIn: 'Immediately check in',
  addLiveWith_copyPackage: 'copy package',
  addLiveWith_same_rsvn_no: 'same rsvn No.',
  addLiveWith_name: 'name',
  addLiveWith_name_place: 'name（required）',

  delayIn_Title:"Extend Stay",
  delayIn_newEndDate:"Dept. Date（New）",
  delayIn_EndDate:"Dept. Date",
  delayIn_days:"Extend Days",
  delayIn_confirm:"Confirm the departure date：",
  delayIn_success: 'Extend Stay Successfully',

  //入账
  incomeAccount_tilte:"Post",
  incomeAccount_roomNo:"Rm No.",
  incomeAccount_name:"Name",
  incomeAccount_code:"Code",
  incomeAccount_fee:"Amount",
  incomeAccount_fee_placehold:"Must fill in",
  incomeAccount_orderNo:"Reference",
  incomeAccount_remark:"Supplement",
  incomeAccount_save:"Post",
  incomeAccount_empty_feeCode:"Please select a transcation code",
  incomeAccount_empty_money:"Please enter the amount",
  incomeAccount_error_money:"Please enter the correct amount.",
  incomeAccount_confirm_money:"Sure to post：",
  incomeAccount_success:"Post Successfully",

  incomeAccount_select_subAccount_pl:"Select sub account",
  incomeAccount_select_subAccount_title:"Sub account",
  incomeAccount_msg_select_subAccount:"Please select sub account",
  incomeAccount_msg_ar_company:"Please select the signing company",
  incomeAccount_msg_ar_account:"Please select the signer",
  incomeAccount_msg_ar_select_company:"AR Acc.",
  incomeAccount_msg_ar_select_amount:"Money",
  incomeAccount_msg_ar_arno:"Arno",
  incomeAccount_msg_ar_coding:"Coding",
  incomeAccount_msg_ar_avaliable_date:"period",
  incomeAccount_msg_ar_avaliable_date_center:"to",

  incomeAccount_msg_ar_no_date: 'This company is not in period of validity',
  incomeAccount_msg_ar_no_status: 'This company is not avaliable',

  //更新订单备注
  updateRemark_title:"Append to comments",
  updateRemark_confirm:"Sure to Append comments?",
  updateRemark_notEmpty:"Comments can't be empty",

  //orderList
  orderList_title: "Resv. List",
  orderList_searchText_placeholder: "Name/Mobile/Resv. No.",
  orderList_notArr: "Arr. expected",
  orderList_hasArr: "Arr. actual today",
  orderList_alkHasArr: "Arr. actual all",
  orderList_notDep: "Dept. expected",
  orderList_hasDep: "Dept. actual",
  orderList_allReserve: "Valid Resv.",
  orderList_rsvNo: "Resv. No.",
  orderList_rsvClassF: "FIT",
  orderList_rsvClassD: "HOUR",
  orderList_rsvClassG: "Group",
  orderList_username: "Name",
  orderList_mobile: "Mobile",
  orderList_arr: "Arr.-Dept.",
  orderList_rmnum: "Rms",
  orderList_rmtype: "Rm type",
  orderList_realRate: " Rate",
  orderList_member_no: "Member No.",
  orderList_member_crpName: "Company",
  orderList_category_name: "Sales",
  orderList_showCategory: "[Clear]",
  orderList_arr_S: "Arr.Date from--to",
  orderList_tip: "Act only on \"Valid Resv\"",
  orderList_dep_S: "Dept. Date from--to--",

  orderList_total: "Total",
  orderList_rmnum: "rm.num",
  orderList_ordernum: "order.num",
  orderList_peoplenum: "people.num",


  //orderDetail
  orderDetail_title: "Resv. Detail",
  orderDetail_crsNo: "No.",
  orderDetail_sta: "Status",
  orderDetail_checkIn_info: "Rm Info",
  orderDetail_rsvArrDate: "Arr.",
  orderDetail_rsvDepDate: "Dept.",
  orderDetail_rmtypes: "Rm type",
  orderDetail_rmtypes_unit: "Rms",
  orderDetail_paiF: "Assign",
  orderDetail_arr: "Arr.",
  orderDetail_dep: "Dept.",
  orderDetail_pick_room: "Choose Room",

  orderDetail_realRate: "Rate",
  orderDetail_name: "Name",
  orderDetail_idNo: "ID No.",
  orderDetail_rsvNo: "Rm No.",
  orderDetail_sex: "Gender",
  orderDetail_sex1: "M",
  orderDetail_sex2: "F",
  orderDetail_staI: "I",
  orderDetail_staO: "O",
  orderDetail_staS: "S",
  orderDetail_staX: "X",
  orderDetail_realRate: "Rate",
  orderDetail_isSecretRate: "【No Print】",
  orderDetail_totalmoney: "Total Rm Charge",
  orderDetail_bookInfo: "Resv. Info",
  orderDetail_bookName: "Name",
  orderDetail_memberNo: "Card No.",
  orderDetail_mobile: "Mobile",
  orderDetail_mobile_placeholder: "Mobile No.（Or null）",
  orderDetail_payment_info: "Prepaid Info",
  orderDetail_pay: "Deposit",
  orderDetail_credit: "Credit",
  orderDetail_charge: "Balance",

  orderDetail_checkin: "Assign/Check in",
  orderDetail_guest_info: "Guest Info",
  orderDetail_guest_name: "Name",
  orderDetail_guest_name_placeholder: "Please enter the name",
  orderDetail_search_room: "Search room in this reservation",
  orderDetail_room: "Rm No",
  orderDetail_has_chosen: "Has Chosen",
  //repair
  repair_title: "Room Details",
  repair_staS: "OS",
  repair_staO: "OO",
  repair_begin: "Begin",
  repair_end: "End",
  //meetingOrder
  meetingOrder_title: "Meeting Resv.",
  meetingOrder_seachContent_placeholder: "Subject/Resv. Name/Contacts/Phone",
  meetingOrder_all: "All",
  meetingOrder_theme: "Subject",
  meetingOrder_order: "Order",
  meetingOrder_fast: "Fast",
  meetingOrder_dateBegin: "Begin",
  meetingOrder_dateEnd: "End",
  meetingOrder_linkMan: "Name",
  meetingOrder_phone: "Phone",
  meetingOrder_sort: "Sort",

  meetingOrder_in_the_day: "Intraday",
  meetingOrder_today: "Today",
  meetingOrder_tomorrow: "Tomorrow",
  meetingOrder_tomorrow2: "The day after tomorrow",
  meetingOrder_orderdata1: "By Time",
  meetingOrder_orderdata2: "By Venue",

  meetingOrder_staR: "TEN",
  meetingOrder_staI: "DEF",
  meetingOrder_staX: "Cancelled",
  meetingOrder_staD: "Deleted",
  meetingOrder_staG: "GUAR",
  meetingOrder_staS: "HSE",
  meetingOrder_staO: "MAINT",
  //meetingBook
  meetingBook_title1: "Booking",
  meetingBook_title: "Editing",
  meetingBook_theme_placeholder: "Please enter the subject",
  meetingBook_categoryCode: "Banquet Type",
  meetingBook_linkman: "Contacts",
  meetingBook_linkman_placeholder: "Please enter the contacts",
  meetingBook_phone: "Phone",
  meetingBook_phone_placeholder: "Please enter the phone No.",
  meetingBook_board: "Sign",
  meetingBook_board_placeholder: "Meeting sign（Or null）",

  meetingBook_rsvName: "Resv. Name",
  meetingBook_booking: "Resv. During",
  meetingBook_rsvName_placeholder: "Reservation name（Or null）",
  meetingBook_peopleNumber: "Persons",
  meetingBook_peopleNumber_placeholder: "Number of persons（Or null）",
  meetingBook_tables: "Tables",
  meetingBook_tables_placeholder: "Number of tables（Or null）",
  meetingBook_rate: "Charge",
  meetingBook_rate_placeholder: "The charge（Or null）",
  meetingBook_resRate: "Resources",
  meetingBook_resRate_placeholder: "The charge of resources（Or null）",
  meetingBook_comRate: "Other charge",
  meetingBook_comRate_placeholder: "other charge（Or null）",

  meetingBook_agreement_unit: "Corporation",
  meetingBook_remark: "Comments",
  meetingBook_not_support: "This hotel do not support Meeting Book",

  meetingBook_meeting_room: "Meeting(s)",
  meetingBook_meeting_room_unit: " ",
  meetingBook_events_list: "Listing",
  meetingBook_tip: "Click date to modify time",
  //meetingCancel
  meetingCancel_title: " Batch Cancel",
  //meetingEdit
  meetingEdit_title: "Batch",
  meetingEdit_theme: "Subject",
  meetingEdit_theme_placeholder: "Enter the new subjuct",
  meetingEdit_staCode: "Status",
  meetingEdit_staCode_placeholder: "Select another status",
  meetingEdit_board: "Sign",
  meetingEdit_board_placeholder: "Enter the new meeting sign",

  meetingEdit_categoryCode: "Banquet Type",
  meetingEdit_categoryCode_placeholder: "Select another type",
  meetingEdit_rsvName: "Resv. Name",
  meetingEdit_rsvName_placeholder: "Enter the new name",

  meetingEdit_salesman: "Sales",
  meetingEdit_salesman_placeholder: "Select another sales",

  meetingEdit_linkman: "Contacts",
  meetingEdit_linkman_placeholder: "Enter the new contacts",

  meetingEdit_phone: "Phone",
  meetingEdit_phone_placeholder: "Enter the new phone No.",
  meetingEdit_must_select:"Must select",
  //会议详情
  meetingDetail_title:"Meeting Resv. Details",
  meetingDetail_orderNo:"Resv. No.",
  meetingDetail_totalFee:"Total",
  meetingDetail_placeInfo:"Venue Info",
  meetingDetail_catNo:"Banquet No.",
  meetingDetail_categoryCode:"Banquet Type",
  meetingDetail_theme:"Subjuct",
  meetingDetail_sta:"Status",
  meetingDetail_placeDes:"Venue",
  meetingDetail_board:"Sign",
  meetingDetail_remark:"Comments",
  meetingDetail_orderInfo:"Resv. Info",
  meetingDetail_rsvName:"Resv. Name",
  meetingDetail_tables:"Tables",
  meetingDetail_dateBegin:"Begin",
  meetingDetail_dateEnd:"End",
  meetingDetail_peopleNumber:"Persons",
  meetingDetail_linkMan:"Contacts",
  meetingDetail_tel:"Phone",
  meetingDetail_salesman:"Sales",
  meetingDetail_company:"Corporation",
  meetingDetail_rate:"Charge",
  meetingDetail_comRate:"Omnibus Charge",
  meetingDetail_other:"Other",
  meetingDetail_createDate:"Created on",
  meetingDetail_modifyDate:"Updated on",
  meetingDetail_batModify:"Batch edit",
  meetingDetail_batCancel:"Batch cancel",

  //cityState
  cityState_title: "City-wide Hotel",
  cityState_search_placeholder: "Hotel Name/Code",

  //index_homeData_analysis: "",
  //导航 消息
  //导航 我的
  info_title: "Message",
  info_send_message: "Message",
  info_readStatusNull: "All",
  info_readStatus0: "Unread",
  info_readStatus1: "Read",
  //infoDetail
  infoDetail_title: "Message",
  infoDetail_eventName: "Event",
  infoDetail_noticeContent: "Content",
  infoDetail_hotelNames: "Hotel",
  infoDetail_dateCondition: "Date Terms",
  infoDetail_checkTime: "Time Period",
  infoDetail_quota: "Check Index",
  infoDetail_quotaCondition: "Index Condition",
  infoDetail_values: "Actual Data",
  infoDetail_noticeDatetime: "Operation Time",
  infoDetail_close: "OK",

  // pushMessage 消息推送
  pushMessage_page_title: 'Message',
  pushMessage_title: 'Title',
  pushMessage_content: 'Content',
  pushMessage_receiver: 'Receiver',
  pushMessage_receiver_placeholder: 'Please select receiver (less then 20 people)',
  pushMessage_require_title: 'Please insert title',
  pushMessage_title_too_long: 'Title is too long, less than 40 words please',
  pushMessage_require_content: 'Please insert content',
  pushMessage_require_receiver: 'Please select receiver',
  pushMessage_require_receiver_overmax: 'You can not choose more than 20 people',
  pushMessage_save: 'Send',
  MessageBox_pushMessage_save: 'Sure to send',
  pushMessage_success: 'Send success',

  // pushMessageDetail
  pushMessageDetail_page_title: 'Message Detail',
  pushMessageDetail_title: 'Title',
  pushMessageDetail_content: 'Content',
  pushMessageDetail_sendTime: 'Send Time',
  pushMessageDetail_receive_title: 'Receive status',
  pushMessageDetail_status_readed: 'Read',
  pushMessageDetail_status_no_redead: 'Unread',

  //cateringOrder
  cateringOrder_title: "F&B Order",
  cateringOrder_search_placeholder: "Resv. Name/Name/Phone/Resv. No.",
  cateringOrder_accnt: "Resv. No.",
  cateringOrder_linkMan: "Name",
  cateringOrder_resName: "Resv. Name",
  cateringOrder_tablenoDes: "Main Table",
  cateringOrder_phone: "Phone",
  cateringOrder_gsts: "Persons",
  cateringOrder_bizDate: "Time",
  cateringOrder_shift: "Shift",
  cateringOrder_pccode: "Workstation",
  cateringOrder_beginDate: "Begin",
  cateringOrder_endDate: "End",

  cateringOrder_shift_1:"Morning",
  cateringOrder_shift_2:"Afternoon",
  cateringOrder_shift_3:"Night",
  cateringOrder_shift_4:"Late at night",
  cateringOrder_shift_R:"R",
  cateringOrder_shift_N:"N",
  cateringOrder_shift_C:"C",
  cateringOrder_shift_I:"I",
  cateringOrder_shift_X:"X",
  //cateringDetail
  cateringDetail_title: "F&B Details",
  cateringDetail_venue_info: "Venue Info",
  cateringDetail_hotelCode: "Hotel",
  cateringDetail_shiftDes: "Resv. Dates",
  cateringDetail_pccodeDes: "Workstation",
  cateringDetail_type1Des: "Menu Types",
  cateringDetail_tablenoDes: "Main Table",
  cateringDetail_exttableno: "Expand Table",
  cateringDetail_res_info: "Resv. Info",
  cateringDetail_amount: "Meal Price",
  cateringDetail_standardType: 'Meal Type',
  cateringDetail_numb: "Tables",
  cateringDetail_beginTime: "Begin",
  cateringDetail_modeDes: "Disc. Mode",
  cateringDetail_endTime: "End",
  cateringDetail_pay: "Prepaid Amount",
  cateringDetail_payTypeDes: "Payment",
  cateringDetail_info: "Comments",
  cateringDetail_con_info: "Communication",
  cateringDetail_linkMan: "Contact",
  cateringDetail_phone: "Phone",
  cateringDetail_haccntName: "Guest Info",
  cateringDetail_love: "Guest Pref.",
  cateringDetail_cusinfo: "Corporation",
  cateringDetail_cardNo: "Member No.",
  cateringDetail_cardName: "Member Name",
  cateringDetail_saleInfo: "Sales",
  cateringDetail_marketDes: "Market",
  cateringDetail_sourceDes: "Sourse",
  cateringDetail_cancel_confirm: "Sure to cancel this order？",
  cateringDetail_cancel_success: "Cancel successfully",

  // 餐饮预订
  cateringCreate_title: 'F&B Order',
  cateringCreate_workstation: 'Workstation',
  cateringCreate_peopleNumber: "Persons",
  cateringCreate_peopleNumber_placeholder: 'Please enter them number of persons',
  cateringCreate_bookDate: 'Book Date',
  cateringCreate_bookTime: 'Book Time',
  cateringCreate_bookTime_placeholder: 'Please select book time',
  cateringCreate_linkman: "Contacts",
  cateringCreate_linkman_placeholder: "Please enter the contacts",
  cateringCreate_phone: "Phone",
  cateringCreate_phone_placeholder: "Please enter the phone No.",
  cateringCreate_tableType: "Table Type",
  cateringCreate_tableNo: "Table No",
  cateringCreate_notice_workstation: 'Please select Workstation',
  cateringCreate_notice_bookDate: 'Please select Book Date',
  cateringCreate_notice_success: 'Book successfully',

  //shirtReport
  shirtReport_title: "Cashier Report",
  shirtReport_info: "Payment Info",
  shirtReport_bill_info: "Account Info",
  shirtReport_all_class: "All Shift",
  shirtReport_all_user: "All User",
  //eventinfo
  eventInfo_title: "Event Editing",
  eventInfo_descript: "Name",
  eventInfo_descript_placeholder: "Please enter the event name",
  eventInfo_receiver: 'Event Receiver',
  eventInfo_receiver_placeholder: 'Please select the event receiver',

  addNewEvent_date_con: "Date Terms",
  addNewEvent_date_con_placeholder: "Please enter the event name",
  eventInfo_today: "This day",
  eventInfo_days_advance: "Date range",
  eventInfo_days_start: "Min.",
  eventInfo_days_stop: "Max.",
  eventInfo_timeListAnimation: "Judgment based on future indicators from * to * days",
  eventInfo_pickerValue_label: "Trigger",
  eventInfo_eventTimeInput_label: "Please select the time",
  eventInfo_addEventTime: "+ New",
  eventInfo_conditions: " Judging Condition",
  eventInfo_quotaDescript: "Index",
  eventInfo_operation: "Condition",
  eventInfo_valLeft: "Data Lower Limit",
  eventInfo_valRight: "Condition",
  eventInfo_valRight_placeholder: "Data Upper Limit（Must be greater than the lower limit）",
  eventInfo_val: "Value",
  eventInfo_val_placeholder: "Condition Data",
  eventInfo_addNewConditions: "+ New",
  eventInfo_tip: "Reminder Content",
  eventInfo_checklistVal: "enable",
  eventInfo_tipContent_placeholder: "Must fill in",
  //addNewEvent
  addNewEvent_title: "New Event",
  addNewEvent_date_con: "Date Terms",
  //member
  member_title: "Member Analytics",
  member_time_type: "Period type",
  member_time_type_day: "By Day",
  member_time_type_month: "By Month",
  member_time_trend: "Mem Trend",

  member_mroption: "Mode",
  member_new_member: "New Member",
  member_pay: "Recharge",
  member_pay_detail: "[Details]",
  member_charge: "Revenue",
  member_card_type: "Card Type",
  member_ship_card: "Type",
  member_data_class: "Data Cat.",
  member_dataSort_buyCount: "Reg Qty.",
  member_dataSort_charge: "Recharge",
  member_dataSort_pay: "Revenue",
  member_growType_0: "All",
  member_growType_1: "Online",
  member_growType_2: "Offline",
  member_all_cardType: "All",
  member_trend: "Member of the trend",
  //memberDetailPay
  memberDetailPay_title: "Recharge Details",
  memberDetailPay_payment: "Payment",
  memberDetailPay_amount: "Amount",
  memberDetailPay_total: "Total",
  //memberDetailCharge
  memberDetailCharge_title: "Revenue Details",
  memberDetailPay_category: "Type",
  //memberDetailCharge
  revenueCompare_title: "Revenue comparison",
  revenueCompare_month: "Month",
  revenueCompare_sequential: "YoY",
  revenueCompare_compared: "MoM",
  revenueCompare_rev_ttl: "Total Rev.",
  revenueCompare_rev_rm: "Rm Rev.",
  revenueCompare_rev_fb: "F&B Rev.",
  revenueCompare_rev_ot: "Oth. Rev.",
  revenueCompare_rm_avg: "ADR",
  revenueCompare_rm_occ: "Occ%",

  revenueCompare_rev_rmot: 'Rm other',
  revenueCompare_rev_meet: 'Meeting',
  revenueCompare_rev_sport: 'Sprot',
  revenueCompare_rev_ent: 'Ent',
  revenueCompare_rev_ex: 'Ex',

  revenueCompare_by_month: 'By Month',
  revenueCompare_by_day: 'By Day',
  revenueCompare_choose_date: 'Choose date',
  revenueCompare_table_date1: 'Date1',
  revenueCompare_table_date2: 'Date2',
  revenueCompare_choose_get1: 'revenue1',
  revenueCompare_choose_get2: 'revenue2',
  revenueCompare_time_dur1: 'Date Range 1',
  revenueCompare_time_dur2: 'Date Range 2',

  revenueCompare_type_title1: 'this year && last year',
  revenueCompare_type_title2: 'last year && year before last',
  revenueCompare_type_title3: 'two, three years ago',
  revenueCompare_type_title4: 'three, four years ago',
  revenueCompare_type_title_RT: 'this year && year before last',
  revenueCompare_type_title_custom: 'custom year',

  revenueCompare_type_lastyear1: 'year before last',
  revenueCompare_type_lastyear2: 'three years ago',
  revenueCompare_type_lastyear3: 'four years ago',

  revenueCompare_message1: 'Date range 2 end date can not be more than today',
  revenueCompare_message2: 'Time durating can not longer than 30 days',


  // revenueReportChart // 营收图表
  revenueReportChart_title: 'Revenue Chart',

  //revenueReport
  revenueReport_title: "Revenue",
  revenueReport_project: "Revenue",
  revenueReport_quantity: "Quantity",
  revenueReport_daily: "Day",
  revenueReport_month: "Month",
  revenueReport_year: "Year",
  revenueReport_nothing: "Nothing,please check the night aduit",
  //cashierReport
  cashierReport_title: "Collection",
  cashierReport_project: "Items",
  //payReport
  payReport_title: "Collection&Revenue",
  payReport_title1: "Payment",
  payReport_title2: "Income",
  //roomPrediectionReport
  roomPrediectionReport_title: "Room Forecast",
  roomPrediectionReport_title1: "Payment",
  roomPrediectionReport_saled: "Occ.",
  //orderFromReport
  orderFromReport_title: "Source Situation",
  orderFromReport_switchbtn_title: "Market",
  orderFromReport_switchbtn_title2: "Channel",
  orderFromReport_switchbtn_title3: "Source",
  orderFromReport_choose: "Selection Index",
  orderFromReport_rent: "Occ.",
  orderFromReport_rm_avg: "ADR",
  orderFromReport_rm_occ: "Occ%",
  orderFromReport_total_charge: "Rm Rev.",
  orderFromReport_rev_rm: "Rm Rev.",
  orderFromReport_chart_series_name: "访问来源",

  RmtypeFloor_title: "Rmtype & Frool",
  RmtypeFloor_switchbtn_title: "RmType",
  RmtypeFloor_switchbtn_title2: "Floor",
  RmtypeFloor_switchbtn_title3: "Building",
  RmtypeFloor_choose: "Selection Index",
  opera_index_detail_title: 'Business data',

  //indexDetail
  indexDetail_title: "Rankings",
  indexDetail_sort: "",
  indexDetail_rentRate: "Occ%",
  indexDetail_revenue: "Total Rev.",
  indexDetail_roomrevenue: "Rm Rev.",
  indexDetail_foodrevenue: "F&B Rev.",
  indexDetail_avgPrice: "ADR",
  indexDetail_revMem: "Member Rev.",
  indexDetail_revEnt: "Ent. Rev.",
  indexDetail_revHrs: "Hourly Rm Rev.",
  indexDetail_otherrevenue: "Oth. Rev.",
  //indexDesc
  indexDesc_title: "Index Explanation",
  indexDesc_total_revenue: "Today Total Rev.",
  indexDesc_total_revenue_value: "Expected Rm Rev.(Exclude Hourly Rms)+",
  indexDesc_total_revenue_value1: "F&B Rev.+Oth. Rev.",
  indexDesc_available: "Avl.",
  indexDesc_available_value: "Number of available rooms on the day",
  indexDesc_take_up_room: "Occ.",
  indexDesc_take_up_room_value: "Current In House - Expected Dept. + Expected Arr.",
  indexDesc_take_up_room_value_normal: "Current In House - Expected Dept. + Expected Arr. - Self Use - Free room",
  indexDesc_overnight_rate: "Occ%",
  indexDesc_overnight_rate_value: "Occupancy/Total Rooms",
  indexDesc_night_average_value: "Expected Room Revenue(Exclude Hourly Rms)/Occupancy",
  indexDesc_night_average: "ADR",
  indexDesc_REVPAR_value: "Occ% * ADR",
  indexDesc_total_rooms: "Total Rms",
  indexDesc_total_rooms_value: "Rooms（Exclude Pseudo Room）",
  indexDesc_since_room: "HSE",
  indexDesc_since_room_value: "Registration form with market code for ",
  indexDesc_since_room_value1: "\"House Use\", not include into Occ.",
  indexDesc_free_room: "COMP",
  indexDesc_free_room_value: "Registration form with market code for",
  indexDesc_free_room_value1: "\"Complimentary\", not include into Occ.",
  indexDesc_maintenance_room: "OO",
  indexDesc_maintenance_room_value: "The room status is \"OO\",",
  indexDesc_maintenance_room_value1: " not include into Occ ",
  indexDesc_locked_room: "OS",
  indexDesc_locked_room_value: "The room status is \"OS\"，",
  indexDesc_locked_room_value1: "Avl. contants \"OS\" ",

  index_homeData_notarrRoom_value: 'Today not arrived room number',
  index_homeData_isarrRoom_value: 'Today already arrived room number',
  index_homeData_notdepRoom_value: 'Today not departure room number',
  index_homeData_isdepRoom_value: 'Today already departure room number',


  indexDesc_chart_desc:"PS. The pie chart is said each type of, the whole circle of metrics do not represent the total number of rooms",
  //version
  version_title: "Version Info",
  version_version: "Version",
  version_tip1: "New interface style with customizable function buttons similar to the Alipay App home page.",
  version_tip2: "Add a message module, quickly receive a useful notification",
  version_tip3: "Increase F&B, Meeting reservation inquiry",
  version_tip4: "Increase Warning Events,alert to hotel key indicators",
  //cacheManger
  cacheManger_title: "Cache Management",
  cacheManger_clear: "Clear",
  cacheManger_clearCloudAddress: "Clear address cache",
  cacheManger_clearCloudParamCache: "Clear parameter cache",
  cacheManger_clearCloudWithoutUserInfo: "Clear all caches except personal information",
  cacheManger_clearAddress: "Clear local address cache",
  cacheManger_clearParamCache: "Clear native parameter caching",
  cacheManger_clearAllWithoutUserInfo: "Clear all local caches except personal information",
  //configeHotel
  configeHotel_title: "Configure Hotels of Concern",
  //couponUse
  couponUse_title: "Use Coupon",
  couponUse_workstation:"WKS",
  couponUse_TodaySum:"Today Count",
  couponUse_Hotel:"Hotel",
  couponUse_Unit:"",
  couponUse_Num: "No.",
  couponUse_sta: "Sta.",
  couponUse_P: "Per.",
  couponUse_Can_workstation: "Fit WKS",
  couponUse_tip: "Please scan first",
  couponUse_need_workstation: "Need set workstation",
  couponUse_error_workstation: "Error workstation",
  couponUse_sta: "Status",
  couponUse_couponName: "Name",
  couponUse_couponCode: "Code",
  couponUse_couponTyDes: "Type",
  couponUse_cardNo: "Mem. No.",
  couponUse_couponType: "Value",
  couponUse_hotelDateSet: "Fit Date",
  couponUse_validFromDate: "Start Date",
  couponUse_validToDate: "End Date",
  couponUse_couponDes: "Describle",
  couponUse_remark: "Comments",
  couponUse_dis: "Coupons are not available",
  couponUse_getbarcode: "Scan",
  couponUse_btnv: "Use",
  couponUse_CouponUseSetting: "Sysoption",
  couponUse_CouponUseHistory: "History Query",
  couponUse_search_title:"History Query",
  couponUse_search_user:"Use man",
  couponUse_search_date:"date",
  couponUse_search_MemName:"Mem. name",

  //命名规则 路由+字段
  center_event_warning: "Warning Events",
  center_feedback: "Feedback",
  center_share_APP: "Share APP",
  center_cacheMange: "Cache Mgt.",
  center_pushSend: "Message Push",
  center_version: "Version",
  center_licManage: "Manage Authorized Client",
  center_selfReportSetting:"User-defined Reports",
  center_thirdUrlSetting:"Expansion-program setting",
  center_unBind:"Unbind Device",
  center_unBind_confirm:"Are you sure to Unbind Device?",

  center_clear_all_cache_title: 'Clear All Cache',
  center_clear_all_cache: 'Sure to clear all cache?',
  center_clear_all_cache_success: 'Clear cache success',

  center_setting: "Sysoption",
  center_message: "Will leave the app to the third-party survey platform,whether to continue？",
  //个人信息
  centerinfo_title: "Personal Info",
  centerinfo_code: "User Name",
  centerinfo_mac: "Device ID",
  centerinfo_version: "PMS Version",

  //事件预警
  eventWorm_title: "Warning Events",
  eventWorm_descript: "Event",
  eventWorm_conditions: "Condition",
  eventWorm_notice_content: "Content",
  eventWorm_day_conditions: "Days Condition",
  eventWorm_today: "Intraday",
  eventWorm_advance: "Advance",
  eventWorm_day: "Days",
  eventWorm_triggering_time: "Trigger",
  //版本号，版本信息 建议直接对应的if else写死
  //授权客户端
  licManage_title: "Authorized Clients",
  licManage_hotelCode: "Hotel",
  licManage_limit: "Limit",
  licManage_client_number: "Clients",
  licManage_all_records: "Total",
  licManage_records_unit: "Records",
  licManage_prompt: "Tip:Left-stroke delete record",
  //授权客户端
  setting_title: "Sysoption",
  setting_account_security: "Account and Security",
  setting_select_shift: "Shift",
  setting_message_notice: "New Message",
  setting_clean_localStorage: "Clear the local cache",
  settinge_device: "Device Info",
  setting_mobileOrder_url: 'Set Mobile Catering Url',
  setting_sys_option: 'Set System Options',

  // 系统参数设置
  setting_sys_option_desc:'Desc',
  setting_sys_option_key:'Key',
  setting_sys_option_value:'Value',

  //账号和安全
  account_title: "Account and Security",
  account_lockerTip: "Gesture Password",
  account_lockerTip_sta_1: "Has Been Set",
  account_lockerTip_sta_2: "Inactive",
  account_lockerTip_label: "Gesture password is valid only on this machine",
  account_tip: "If your account is not properly logged in, please change your password in time and contact the administrato.",
  //accountLocker
  accountLocker_title: "Gesture Password",
  accountLocker_1: "Enable gesture password",
  accountLocker_2: "Update gesture password",
  accountLocker_tip:
      "Gesture password is valid only on this machine, logon password will not be saved after disabling gesture password, exit account need to be reset.",
  //anypay
  anypay_title: "Any Pay",
  anypay_des: "Amount",
  anypay_loading: "Payment processing in...",
  anypay_action_search: "TX Query",
  anypay_action_goRefund: "TX Refund",
  anypay_action_reAccount: "Posting Check",
  anypay_scene: "Scan Pay",
  anypay_overtime: "Payment Timeout",
  anypay_backspace:"Backspace ",
  anypay_alipay_wechat:'AliPay/WeChat',

  msg_goRefund: "You don't have the right to refund",
  msg_payOrder: "Incorrect payment amount",
  msg_getbarcode: "Non-effective payment QR code",
  msg_paySuccess: "Payment Success",
  msg_keyDown: "Please enter the payment amount",
  msg_than_price: "Exceed the maximum amount",
  msg_reAccount: "No last order number record, can not check the account, please manually handle if there is an exception ",
  MessageBox_closeQ: "Sure to give up this payment??",
  //anyrefundList
  anyrefundList_title: "Refund",
  anyrefundList_id: "Resv. No.",
  anyrefundList_feeName: "Items",
  anyrefundList_feeCode: "Trans. Code",
  anyrefundList_totalMoney: "Total",
  anyrefundList_createDate: "Payment Time",
  anyrefundList_taNo: "Voucher No.",
  anyrefundList_taWay: "Payment",
  anyrefundList_feeName: "Items",
  anyrefundList_payMoney: "Amount",
  anyrefundList_status: "Status",
  anyrefundList_detail: "Details",
  anyrefundList_alter: "CXL C/O",
  anyrefundList_alter_success: "Cancel C/O Success",
  anyrefundList_nothing: "There's nothing",
  anyrefundList_nothingTxt: "Please enter the query conditions for refund orders",
  anyrefundList_nothingTxt1: "(Refundable order only for the day）",
  anyrefundList_order_detail: "Order Details",
  anyrefundList_action_anpay: "Cashier",
  anyrefundList_action_RefundList: "Transaction Query",
  anyrefundList_scene: "Scan Pay to Refund",
  msg_refundOrder_sta: "The refund status is:",
  msg_checkOutRevoke: "Bills cancel C/O successfully",
  msg_anyrefundList_search: "Query content cannot be empty",
  MessageBox_showAlter: "Sure to cancel C/O the order?",
  //账号和安全
  anypaySearch_title: "Transaction Query",
  anypaySearch_orderNumer_placeholder: "Voucher No. / Resv. No.",
  //pushSend
  pushSend_title: "Push Send",
  pushSend_product: "Target System",
  pushSend_product_placeholder: "Target System(Must fill in)",
  pushSend_hotelGroupCode: "Group Code",
  pushSend_hotelCode: "Hotel Code",
  pushSend_loginName: "User Name",
  pushSend_push_title: "Heading(Must fill in)",
  pushSend_overview: "Subhead",
  pushSend_content: "Content(Must fill in)",
  pushSend_url: "Connect Address",
  pushSend_save: "Push",
  msg_save1: "Push",
  msg_save2: "Records",
  MessageBox_pushSend_save: "Sure to push?",
  //memberSearch
  memberSearch_title: "Member Search",
  memberSearch_searchType_placeholder: "Condition Type",
  memberSearch_seachContent_placeholder: "Search Criteria",
  memberSearch_name: "Name",
  memberSearch_cardNo: "Member No.",
  memberSearch_mobile: "Phone",
  memberSearch_address: "Address",
  memberSearch_dis: "Please enter the search criteria",
  memberSearch_searchType_cardNo: "Member No.",
  memberSearch_searchType_name: "Name",
  memberSearch_searchType_mobile: "Phone",
  memberSearch_searchType_idNo: "ID No.",
  memberSearch_searchType_email: "E-Mail",
  msg_searchType: "Please select the search criteria type",
  msg_searchOption: "Please enter the search criteria ",
  //memberDetail
  memberDetail_title: "Member Details",
  memberDetail_cardNo: "Main Card No.",
  memberDetail_sta: "Status",
  memberDetail_base_info: "Basic Info",
  memberDetail_name: "Name",
  memberDetail_sex: "Gender",
  memberDetail_birth: "Birth",
  memberDetail_isWechatMem: "Whether WeChat member",
  memberDetail_accountBalance: "Stored value balance",
  memberDetail_pointBalance: "Available Points",
  memberDetail_accountTreatBalance: "Gift Balance",
  memberDetail_idTypeDescript: "ID Type",
  memberDetail_idNo: "ID No.",
  memberDetail_companyName: "Corporation",
  memberDetail_loginTime: "Login Time",
  memberDetail_createDatetime: "REG Time",
  memberDetail_rateCode: "Rate Code",
  memberDetail_book: "New Resv.",
  memberDetail_contact_info: "Contact Info",
  memberDetail_mobile: "Phone",
  memberDetail_email: "E-Mail",
  memberDetail_phone: "Phone",
  memberDetail_address: "Address",
  memberDetail_card_info: "Card Info",
  memberDetail_cardNo2: "Member No.",
  memberDetail_cardTypeDescript: "Member Plan",
  memberDetail_cardLevelDescript: "Level",
  memberDetail_staDescript: "Status",
  memberDetail_pointBalance: "Points Balance",
  memberDetail_accountBalance: "Stored Value Balance",
  memberDetail_checkOutTime: "Late C/O Time",
  memberDetail_validity: "Validity",
  //memberDetail_createDatetime: "REG Time",
  //memberRegister
  memberRegister_title: "Register",
  memberRegister_cardType: "Member Plan",
  memberRegister_cardLevel: "Member Level",
  memberRegister_taCode: "Pay Type",
  memberRegister_taMoney: "Pay Money",
  memberRegister_msg_no_taCode: "Please select a pay way",
  memberRegister_name: "Name",
  memberRegister_name_placeholder: "Please enter the member name（Must fill in）",
  memberRegister_sex: "Gender",
  memberRegister_sex_placeholder: "Cannot be empty",
  memberRegister_mobile: "Phone",
  memberRegister_mobile_placeholder: "Please enter the phone No.（Must fill in）",
  memberRegister_password: "Original Password",
  memberRegister_password_placeholder: "（Must fill in）",
  memberRegister_email_placeholder: "Please enter the E-Mail address（Or null）",
  memberRegister_idType: "ID Type",
  memberRegister_idNo: "ID No.",
  memberRegister_idNo_placeholder: "Please enter the ID No.(Or null)",
  memberRegister_cardSrc: "Source",
  memberRegister_cardSrc_placeholder: "Can be empty",
  memberRegister_salesman: "Sales",
  memberRegister_salesman_placeholder: "Can be empty",
  memberRegister_confirm: "Register",
  msg_sfzRe: "Identification failed! Please aim at the ID card and take the picture when it is clear.",
  msg_isEmpty_name: "Name cannot be empty",
  msg_isEmpty_mobile: "Phone cannot be empty",
  msg_isEmpty_password: "Password cannot be empty",
  msg_book: "Registered Successfully",
  MessageBox_confirmB: "Sure to register?",
  //AccountIn
  AccountIn_title: "Post",
  AccountIn_rmno: "Rm No.",
  AccountIn_name: "Name",
  AccountIn_taCode: "Code",
  AccountIn_clubCard: "Member",
  AccountIn_money: "Amount",
  AccountIn_money_placeholder: "Please enter the amount（Must fill in）",
  AccountIn_taNo: "Reference",
  AccountIn_taRemark: "Supplement",
  AccountIn_save: "Post",
  msg_isEmpty_taCode: "Please select a transaction code",
  msg_isEmpty_cardNo: "Please select a card",
  msg_isEmpty_money: "Please enter the amount",
  msg_isEmpty_money2: "Please enter the correct amount",
  MessageBox_AccountIn_save: "Sure to post：",
  MessageBox_AccountIn_remove_item: "Sure to remove this item?",

  JJ_AccountIn_title: 'Account Adjust',
  JJ_AccountIn_reason: 'Reason',
  msg_need_reason: 'Please choose reason',

  //selfReportSetting
  selfReportSetting_title: "User-defined Reports",
  selfReportSetting_name: "Report Name",
  selfReportSetting_name_placeholder: "建议2-6个字",
  selfReportSetting_code: "Report Code",
  selfReportSetting_code_placeholder: "Please enter the Procedure name（Must fill in）",
  selfReportSetting_procName: "Procedure Name",
  selfReportSetting_procName_placeholder: "Procedure Name",
  selfReportSetting_type: "Template Type",
  selfReportSetting_type_tip2: "Single Date is 3 params<br>Range Date is 4 params",
  selfReportSetting_icon: "Icon",
  selfReportSetting_icon_placeholder: "Select Icon",
  selfReportSetting_color: "Color",
  selfReportSetting_color_placeholder: "Select Color",
  selfReportSetting_data_src: " Data Sources",
  selfReportSetting_data_src_placeholder: "Cannot be empty",
  selfReportSetting_createDate: " Created On",
  selfReportSetting_deleteEv: "Deleted Successfully ",
  //selfReportEdit
  selfReportEdit_title: "Define Report",
  selfReportEdit_column: "Field Info",
  selfReportEdit_column_c: "Col.",
  selfReportEdit_column_n: "Name",
  selfReportEdit_column_w: "With%",
  selfReportEdit_column_addC: "Add",
  selfReportEdit_column_number: "No.",
  selfReportEdit_column_field: "Field",
  selfReportEdit_column_chinese: "Name",
  selfReportEdit_column_i: "Index Condition:Field,Value (Can Empty)",
    selfReportEdit_column_i_tip: "Example：type:1",
  selfReportEdit_column_a: "Align",
  selfReportEdit_column_a_tip: "left,right,center",
  selfReportEdit_column_action: "Opt.",
  selfReportEdit_column_Index:"Ind.",
  selfReportEdit_column_JSON:"View JSON",
  selfReportEdit_column_b:"Imp.",
  selfReportEdit_users: "Rights",
  selfReportEdit_users_placeholder: "Input Pms Right key",
  selfReportEdit_disOption: "View Options",
  selfReportEdit_ext2: "显示扩展2",
  selfReportEdit_ext3: "显示扩展3",
  selfReportEdit_listOrder: "Sort",
  selfReportEdit_listOrder_placeholder: "Sort No.(Or null)",
  selfReportEdit_ext_placeholder: "Can be empty",
  selfReportEdit_ishalt: "Is Halt",
  selfReportEdit_ishalt_placeholder: "Cannot be empty",
  selfReportEdit_remark: "Comments",
  selfReportEdit_dataType_dateTable: "Single Date Table",
  selfReportEdit_dataType_rangTable: "Range Date Table",
  selfReportEdit_First_line_sum:"First Line Sum",
  selfReportEdit_Auto_scroll :"Auto Scroll",

  selfReportEdit_dataType_group: "Group",
  selfReportEdit_dataType_pms: "Hotel（Not Support）",
  selfReportEdit_dataType_member: "Member（Not Support）",

  selfReportEdit_TF_F: "Enable",
  selfReportEdit_TF_T: "Disable",

  // thirdUrlSetting
  thirdUrlSetting_title: 'Expansion-program Setting',
  thirdUrlSetting_createDate: " Created On",

  // thirdUrlEdit
  thirdUrlSetting_code: 'Exp.code',
  thirdUrlSetting_code_placeholder: 'Please enter the Exp.code（Must fill in）',
  thirdUrlSetting_name: 'Exp.name',
  thirdUrlSetting_name_placeholder: 'Please enter the Exp.name（Must fill in）',
  thirdUrlSetting_url: 'Exp.url',
  thirdUrlSetting_url_placeholder: 'Please enter the Exp.url （Must fill in）',
  thirdUrl_msg_isEmpty_code: "Exp.code can't be empty",
  thirdUrl_msg_isEmpty_name: "Exp.name can't be empty",
  thirdUrl_msg_isEmpty_url: "Exp.url can't be empty",

  msg_isEmpty_addColumn_c: "Column can't be empty",
  msg_isEmpty_addColumn_n: "Name can't be empty",
  msg_isEmpty_addColumn_w: "Width can't be empty",

  msg_isEmpty_code: "Code can't be empty",
  msg_isEmpty_name: "Name cannot be blank",
  msg_isEmpty_procName: "Process name cannot be empty",
  msg_isEmpty_right: "Right key cannot be empty",
  msg_isEmpty_columns: "Columns can't be empty",
  msg_only_group: "Only Support On Group",
  //couponUseSetting
  couponUseSetting_title: "Use Coupon Settings",
  couponUseSetting_operating_point: "WKS",
  //账号和安
  messagePush_title: "New message settings",
  messagePush_receiveAlert: "Receive warning messages",
  messagePush_receiveSystem: "Receive system messages",
  messagePush_startApp: "Receives the messages to start APP",
  messagePush_vibration: "Turn on the vibrations",
  messagePush_voice: "Sound",
  messagePush_tipBox: "When the APP is running, you can set up sound or vibration.",

  //账号和安全
  device_title: "Device Info",
  device_name: "System Name",
  device_language: "Language",
  device_version: "Version",
  device_vendor: "System Supplier",
  device_model: "Unit Type",
  device_vendor2: "MFR",
  device_mac: "Device ID",
  device_network: "Network Type",
  device_screen: "Resolution",
  device_scale: "Display Ratio",
  device_scale: "Display Ratio",
  device_uuid: "Device ID",
  device_message: "Re-login after clearing the local cache, continue or not?",

  //账务代码
  accountCode_Title:"Items",
  accountCode_SearchPlaceHold:"Search by code or name",
  accountCode_common:"Commonly",
  accountCode_fee:"Consumption",
  accountCode_pay:"Payment",
  accountCode_preAuth: 'PreAuth',
  accountCode_list:"List",

  //日期酒店搜索
  dateHotel_SearchHotel:"Please select the hotel",

  //日期控件
  controll_datepicker_to:"To",
  controll_datepicker_clear:"Clear",
  controll_datepicker_selectEndDate:"Please select the end time",

  controll_datepik_no_next:"Cannot go on to next",
  controll_datepik_no_pre:"Cannot go on to before",

  //弹框搜索会员协议公司
  pop_search_isGroup:'Wheather group search',
  pop_search_cardNo:'Member No.',
  pop_search_mobile:'Phone',
  pop_search_idNo:'ID No.',
  pop_search_cardType:'Card Type',
  pop_search_rateCode:'Rate Code',
  pop_search_No:'No.',
  pop_search_src:'Source',
  pop_search_market:'Market',
  pop_search_cms:'Commission',
  pop_search_saleman:'Sales',
  pop_search_searchTile:'Please enter the search criteria',
  pop_search_mem_placeHolder:'Search Membership Card',
  pop_search_mem_SearchplaceHolder:'Please enter the member No./Phone No.',
  pop_search_A_placeHolder:'Search Agent',
  pop_search_A_SearchplaceHolder:'Please enter the travel agency',
  pop_search_C_placeHolder:'Search Company',
  pop_search_C_SearchplaceHolder:'Please enter the company',
  pop_search_S_placeHolder:'Search OTA',
  pop_search_S_SearchplaceHolder:'Please enter the OTA',

  //酒店搜索
  contrll_search_range:"Select a range",
  //控件topDatePick
  contrll_topDatePick_no_less_today:"Cannot query records earlier than today",
  contrll_no_big_yesterday:"Cannot query records later than yesterday",
  Update_LOG:"Updated logs",
  contrll_at_least:'Please select at least one hotel',
  contrll_self_choice:'Self choose ',
  contrll_num_hotel:' hotels',
  contrll_only_hotel:'Please select a hotel',


  // discover 发现
  discover_title: 'Discover',
  discover_ad_icon: 'AD',

  // loginRecord 登录记录
  loginRecord_title: 'Login Record',
  loginRecord_title_self: 'Self Login Record',
  loginRecord_title_all: 'All Login Record',
  loginRecord_ip: 'Login IP',
  loginRecord_time: 'Login Time',

  // 快速预定会议
  meetingBookFast_page_title: 'Fast Meeting Book',
  meetingBookFast_title: 'Please select meeting room',
  meetingBookFast_select_time: 'Please select time',
  meetingBookFast_time: 'Meeting date',
  meetingBookFast_time_part: 'time part',
  meetingBookFast_msg_selecte_part: 'At least choose one time part',

  // reportViewRange 酒店营收报表范围
  reportViewRange_title: 'Hotel Report View Range',
  reportViewRange_project: 'Project',
  reportViewRange_current_period: 'Current',
  reportViewRange_corresponding_period: 'Correspond',

  // memberContrast 会员对比
  memberContrast_title: 'Member Compare',
  memberContrast_current: 'Current',
  memberContrast_lastyear: 'Last Year',
  memberContrast_compare: 'Compare',

  // memberMoreHotelContrast 会员状况
  memberMoreHotelContrast_title: 'Member Data',
  memberMoreHotelContrast_mem_title: 'Mem card',
  memberMoreHotelContrast_register_time: 'Reg count',
  memberMoreHotelContrast_consume_time: 'Consume count',
  memberMoreHotelContrast_consume_money: 'Consume money',
  memberMoreHotelContrast_charge_money: 'Charge money',

  // memberSingleContrast 会员指标
  memberSingleContrast_title: 'Member indicator',
  memberSingleContrast_quota: 'Quota',

  // memberPerformance 会员总体
  memberPerformance_title: 'Member Performance',
  memberPerformance_order: 'Order',
  memberPerformance_roomIncome: 'Room Rev.',
  memberPerformance_roomProportion: 'Room Per.',
  memberPerformance_roomCompared: 'Room Comp.',

  memberPerformance_foodIncome: 'Cater Rev.',
  memberPerformance_foodProportion: 'Cater Per.',
  memberPerformance_foodCompared: 'Cater Comp.',

  memberPerformance_otherIncome: 'Other Rev.',
  memberPerformance_otherProportion: 'Other Per.',
  memberPerformance_otherCompared: 'Other Comp.',

  // opera orderDetail
  operaOrderDetail_sure_checkout: 'Sure to checkout?',
  operaOrderDetail_sure_money: 'Money should more than 0',
  operaOrderDetail_sure_account_in: 'Sure to account in?',
  operaOrderDetail_sure_not_end: 'Not check-in date',
  operaOrderDetail_sure_checkIn: 'Sure to check in?',
  operaOrderDetail_sure_cancel_reason: 'Please insert cancel reason',
  operaOrderDetail_room: 'room',
  operaOrderDetail_room_choose: 'choosed',
  operaOrderDetail_room_over: 'More than allow room number',
  operaOrderDetail_room_no: 'Please choose a room first！',
  operaOrderDetail_room_special: 'Please choose a room first',
  operaOrderDetail_room_confirm1: 'Sure to set room ',
  operaOrderDetail_room_confirm2: 'Assign',


  // searchHotel
  searchHotel_opera_notice: 'Opera hotel can not be multiple selected',
  searchHotel_opera_notice2: 'Opera hotel can not be selected',

  // operaOrder
  operaOrder_title: 'Check in room',
  operaOrder_live_in_date: 'Check in date',
  operaOrder_room: 'room',
  operaOrder_bookinfo_name: "Insert rsvMan's name（required)",
  operaOrder_bookinfo_mobile: "Insert rsvMan's mobile（required)",
  operaOrder_bookinfo_id: "Id code",
  opera_search_history: "Search history",

  // operaBook
  operaBook_checkin_time: 'Check in time',
  operaBook_leave_time: 'Leave time',
  operaBook_search_rmno: 'Search rate code', // Rate Code



  // 锦江相关
  jj_door_card_info: 'doorCard info',
  jj_room_no: 'roomNo',
  jj_beginTime: 'beginTime',
  jj_endTime: 'endTime',
  jj_doorCard_operate: 'doorCard ope',
  jj_addCard: 'Add Card',
  jj_addCard_success: 'Add card success',
  jj_copyCard: 'Copy Card',
  jj_copyCard_success: 'Copy Card success',
  jj_readCard: 'Read Card',
  jj_readCard_success: 'Read Card success',
  jj_cancelCard: 'Cancel Card',
  jj_cancelCard_success: 'Cancel Card success',
  jj_setting: 'Setting',
  jj_token_error: 'Get jingJiang Token fail, please set jingJiang info first',
  jj_empty_card: 'This is an empty card',
  jj_cancel_text: 'cancel',
  jj_id_card_read_success: 'Id Card read success',
};



// WEBPACK FOOTER //
// ./src/locale/lang/en_US.js